import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 24, mass: 0.3 });
  return (
    <motion.div style={{ scaleX }} className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[120] bg-gradient-to-r from-[#e10032] via-[#ff2a55] to-[#fff]"
      data-testid="scroll-progress" aria-hidden="true">
      <div className="absolute right-0 top-0 h-[3px] w-24 blur-[6px] bg-[#ff2a55]" />
    </motion.div>
  );
}
